module.exports = __webpack_public_path__ + "img/best-seller.d5c5267f.svg";